<template>
	<button
		@click.prevent="redirectToLink()"
		class="flex items-center p-2 lg:py-2 lg:px-5 justify-center cursor-pointer transition duration-150 ease-in-out"
		:class="{
			'bg-slate-50 border rounded-md hover:shadow-md': !borderless,
			'saturate-50 opacity-50 cursor-not-allowed': disable,
			'text-blue-400 border-blue-500 hover:text-blue-500': color === 'blue',
			'text-red-400 border-red-500 hover:text-red-500': color === 'red',
		}">
		<div class="flex">
			<p v-if="slots.icon" :class="{ ' mr-2 lg:mr-3': slots.text }">
				<slot name="icon"></slot>
			</p>
			<p class="font-normal whitespace-nowrap" v-if="slots.text">
				<slot name="text" v-if="!loading"></slot>
				<span v-if="loading"><i class="fa-solid fa-loader animate-spin"></i></span>
			</p>
		</div>
	</button>
</template>

<script setup>
	import { useSlots } from 'vue';

	const slots = useSlots();

	const props = defineProps({
		link: {
			type: String,
			default: null,
		},
		borderless: {
			type: Boolean,
			default: false,
		},
		disable: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: 'blue',
			validator: (value) => ['blue', 'red', 'gray'].includes(value),
		},
		loading: {
			type: Boolean,
			default: false,
		},
	});

	const redirectToLink = () => {
		if (props.link) {
			window.location.href = props.link;
		}
	};
</script>
